/**
 * MO Scroll Lock - Body scroll management
 * Migrated from src/alpine/store/stop-scroll.js
 */
(function () {
  "use strict";

  window.MO = window.MO || {};

  window.MO.scrollLock = {
    enable: function () {
      document.body.classList.add("body-lock");
    },
    disable: function () {
      if (!document.documentElement.classList.contains("prescription-popup-opened")) {
        document.body.classList.remove("body-lock");
      }
    }
  };
})();
